import {
  ClsCiudades,
  ClsContactoCliente,
  ClsClientes,
  ClsEmpresas,
  ClsEstados,
  ClsResponsables,
  ClsVendedores,
  ClsRegion, ClsTipoLicitaciones
} from './cls-catalogos';
import {ClsArbolPartida, ClsConceptosPartida} from './cls-partida';
import { ClsCatalogosExpIns } from './cls-catalogo-general';
import {ClsCatalogoCostosCalculo, ClsCatalogoCostosOPCalculo, ClsCatalogoMOCalculo} from './cls-calculo';
import {ClsCostoHorarios} from './cls-costo-horarios';
import {ClsMatriz} from './cls-matriz';
import {IPptoCompleto} from "./interfaces/generico-interface";

export class ClsOrganizacion {
  IdOrganizacion: bigint;
  RazonSocial: string;
  IdEmpresaDeUsuario: bigint;
}
export class ClsPartidasConceptosExpIns {
  Partidas: ClsArbolPartida[] = [];
  Presupuesto: ClsConceptosPartida[] = [];
  CatExpIns: ClsCatalogosExpIns[] = [];
  Matrices: ClsMatriz[] = [];
  CostoHorarios: ClsCostoHorarios[] = [];
  CostosCalculo: ClsCatalogoCostosCalculo[] = [];
  CostosOPCalculo: ClsCatalogoCostosOPCalculo[] = [];
  CostosMOCalculo: ClsCatalogoMOCalculo[] = [];
  dataPptoCompleto?: IPptoCompleto[] = [];
}

export class ClsProgramaDeObraGrid {
  IdPartidaPadre: bigint;
  IdPartidaPadreS?: string;
  IdPresupuestoPartida: bigint; // se agrega para poder identificar partida unica
  IdPresupuestoPartidaS?: string;
  Partida: string;
  PartidaWBS: string;
  DescripcionLargaPartida: string;
  DescripcionPartida: string;
  Renglon: number;
  Control: number; // se agrega para poder identificar concepto unico
  Codigo: string;
  CodigoAuxiliar: string;
  DescripcionLarga: string;
  Descripcion: string;
  Unidad: string;
  FechaInicio: Date; // por defecto se pone la fecha de inicio del programa de obra
  FechaFinal: Date; // por defecto se pone la fecha de inicio del programa de obra
  Duracion: number; // se calcula la diferencia entre fecha inicio y fecha final
  Rendimiento: number; // se divide cantidad / duracion
  Critica: boolean; // es genererada al calcular
  Holgura: number; // es generada al calcular, por defecto -1 y si es partida es 0`
  Precio: number;
  Cantidad: number; // es 1 por defecto si es partida
  Importe: number;
  IdResponsable: bigint;
  IdResponsableS: string;
  Responsable: string;
  Avance: number;
  CantidadCapturado: number;
  PorcentajeCapturado: number;
  MontoCapturado: number;
  EsPartida: boolean;
  // Contratista?: String; // modulo de control // quitarlo
  // Ubicacion?: number; // modulo de contrtol // quitarlo
}

export class ClsCatalogoPresupuestos {
  IdOrganizacion: bigint;
  RazonSocial: string;
  IdPresupuesto: bigint;
  IdUsuarioCreador: bigint;
  EMailUsuarioCreador: string;
  CodigoPresupuesto: string;
  NombrePresupuesto: string;
  NivelAcceso: number;
  NivelAccesoS?: string;
  FechaVigencia: Date;
  FechaUltimaExportacion: Date;
  TipoPresupuesto: number;
  PorcentajeSobrecosto: number;
  CostoDirecto: number;
  PrecioDeVenta: number;
  IdCiudad: bigint;
  IdCliente: bigint;
  FechaUltimoUso: Date;
  // FechaLicitacion?: Date;
  Ciudad: string;
  Cliente: string;
  PresupuestoAgrupador: number;
  PresupuestoAgrupadorS?: string;
  Agrupador1?: string;
  Agrupador2?: string;
  Agrupador3?: string;
  UrlContenido: string;
  Region?: string;
}

export class ClsPresupuestos {
  IdPresupuesto: bigint;
  IdEmpresaDeUsuario: bigint;
  IdOrganizacion: bigint;
  IdUsuarioCreador: bigint;
  EMailUsuarioCreador: string;
  CodigoPresupuesto: string;
  NombrePresupuesto: string;
  Direccion: string;
  Colonia: string;
  IdEstado: bigint;
  Estado?: ClsEstados;
  IdCiudad: bigint;
  Ciudad?: ClsCiudades;
  CodPost: string;
  Telefono: string;
  EMail: string;
  Observaciones: string;
  Bloqueado: boolean;
  IdResponsable: bigint;
  Responsable?: ClsResponsables;
  Cargo: string;
  IdEmpresa: bigint;
  Empresa?: ClsEmpresas;
  IdCliente: bigint;
  Cliente?: ClsClientes;
  IdVendedor: bigint;
  Vendedor?: ClsVendedores;
  IdClienteContacto: bigint;
  ClienteContacto?: ClsContactoCliente;
  PorcentajeIVA: number;
  FechaUltimoUso: Date;
  RequiereCalcular: boolean;
  RequiereTotalizar: boolean;
  RequiereCalcularWBS: boolean;
  TipoPresupuesto: number;
  FechaUltimaExportacion: Date;
  IdTipoLicitacion: bigint;
  TiposLicitacion?: ClsTipoLicitaciones;
  Region: string;
  Regiones?: ClsRegion;
}

export class ClsUsuarioCompartir {
  IdPresupuestoXUsuario: any;
  IdPresupuesto: any;
  IdCatalogoDeObras?: bigint;
  IdUsuarioCompartido?: bigint;
  EmailUsuarioCompartido: string;
  NivelAcceso?: number;
  NivelAccesoS: string;
  FechaVigencia: Date;
}

export class ClsImportePorTipo {
  CostoMoneda1: number;
  CostoMoneda2: number;
}

export class ClsTipoEquipoHerramienta {
  Tipo: number;
  TipoPorcentaje: number;
}
